import axios from 'axios';
import { toast } from 'react-toastify';
import {
  EVENTS_SAVE_NEW_EVENT_BEGIN,
  EVENTS_SAVE_NEW_EVENT_SUCCESS,
  EVENTS_SAVE_NEW_EVENT_FAILURE,
  EVENTS_SAVE_NEW_EVENT_DISMISS_ERROR,
} from './constants';

import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function saveNewEvent(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: EVENTS_SAVE_NEW_EVENT_BEGIN,
    });

    const { projectId, version } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/events`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: EVENTS_SAVE_NEW_EVENT_SUCCESS,
              data: res.data,
            });
            Mixpanel.track('Created Event', {
              uuid: res.data.uuid,
              eventTitle: res.data.eventTitle,
            });
            toast.success('Created Successfully !');
            resolve(res.data);
          } else {
            dispatch({
              type: EVENTS_SAVE_NEW_EVENT_FAILURE,
              data: { error: 'Failed' },
            });
            Mixpanel.track('Failed to create event');
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: EVENTS_SAVE_NEW_EVENT_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to create event');
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissSaveNewEventError() {
  return {
    type: EVENTS_SAVE_NEW_EVENT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EVENTS_SAVE_NEW_EVENT_BEGIN:
      return {
        ...state,
        saveNewEventPending: true,
        saveNewEventError: null,
      };

    case EVENTS_SAVE_NEW_EVENT_SUCCESS:
      return {
        ...state,
        saveNewEventPending: false,
        saveNewEventError: null,
        saveNewEventPending: false,
        saveNewEventError: null,
        events: [...state.events, action.data],
        selectedEvent: action.data,
      };

    case EVENTS_SAVE_NEW_EVENT_FAILURE:
      return {
        ...state,
        saveNewEventPending: false,
        saveNewEventError: action.data.error,
      };

    case EVENTS_SAVE_NEW_EVENT_DISMISS_ERROR:
      return {
        ...state,
        saveNewEventError: null,
      };

    default:
      return state;
  }
}
